<script lang="ts">import { onMount } from 'svelte';
import { scrollState } from '../../../../js-v2/stores/scroll-state-store';
const { shouldLock = false, delayLockAfter = 0 } = $props();
let lockTimeout = null;
let isCurrentlyLocked = false;
let body;
let overflowY;
let position;
let scrollY;
let width;
function lock() {
    if (typeof window === 'undefined' || !body || isCurrentlyLocked)
        return;
    isCurrentlyLocked = true;
    // Save the current styles and scroll position
    overflowY = body.style.overflowY;
    position = body.style.position;
    width = body.style.width;
    scrollY = window.scrollY;
    if (scrollY) {
        scrollState.setIgnoreNextScroll();
    }
    // Clear any existing timeout to prevent multiple locks
    if (lockTimeout) {
        clearTimeout(lockTimeout);
        lockTimeout = null;
    }
    // Schedule the lock after the specified delay
    lockTimeout = setTimeout(() => {
        if (!body)
            return;
        body.style.overflowY = 'scroll';
        body.style.position = 'fixed';
        body.style.width = '100%';
    }, delayLockAfter); // the time out value should the same as $duration-medium-in
}
function unlock() {
    if (typeof window === 'undefined' || !body || !isCurrentlyLocked)
        return;
    if (lockTimeout) {
        // Clear any pending lock timeout
        clearTimeout(lockTimeout);
        lockTimeout = null;
    }
    // Restore the original styles
    body.style.overflowY = overflowY;
    body.style.position = position;
    body.style.width = width;
    // this check is needed to prevent the page from jumping to the top on initial load (scrollY is undefined) with anchor links
    // only jump when the page is unlocked from a locked state (where scrollY is set)
    if (scrollY) {
        window.scrollTo(0, scrollY);
    }
    isCurrentlyLocked = false;
}
$effect(() => {
    shouldLock ? lock() : unlock();
});
onMount(() => {
    body = document.body;
    overflowY = body.style.overflowY;
    position = body.style.position;
    width = body.style.width;
    // Initial check since body is just mounted
    shouldLock ? lock() : unlock();
    return () => {
        unlock();
    };
});
</script>
